import {SetUserType, UserState} from "./userType";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState: UserState = {
    userEmail: '',
    role: 0,
    userName: '',
    userId: 0,
    lastPlayedAdventure: 0,
    lastHostedAdventure: 0
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<SetUserType>) => {
            state.userEmail = action.payload.userEmail;
            state.userName = action.payload.userName;
            state.role = action.payload.role;
            state.userId = action.payload.userId;
            state.lastPlayedAdventure = action.payload.lastPlayedAdventure;
            state.lastHostedAdventure = action.payload.lastHostedAdventure;
        },
        
        updateLastPlayed: (state, action: PayloadAction<number>) => {
            state.lastPlayedAdventure = action.payload
        },

        updateLastHosted: (state, action: PayloadAction<number>) => {
            state.lastHostedAdventure = action.payload
        }
    }
})

export const {
    setUser,
    updateLastHosted,
    updateLastPlayed
} = userSlice.actions
export default userSlice.reducer